import { createActions } from 'redux-actions';
import { ActionTypes } from 'constants/index';

export const {
  getLocationImports,
  getLocationImport,
  uploadLocationImport,
  updateLocationImportRow,
  approveLocationImport,
  deleteLocationImport,
} = createActions({
  [ActionTypes.GET_LOCATION_IMPORTS]: params => params,
  [ActionTypes.GET_LOCATION_IMPORT]: (id, params) => ({ id, params }),
  [ActionTypes.UPLOAD_LOCATION_IMPORT]: file => ({ file }),
  [ActionTypes.UPDATE_LOCATION_IMPORT_ROW]: (importId, rowId, row) => ({ importId, rowId, row }),
  [ActionTypes.APPROVE_LOCATION_IMPORT]: (importId, payload) => ({ importId, payload }),
  [ActionTypes.DELETE_LOCATION_IMPORT]: id => ({ id }),
});
